export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const REFRESH_ACCESS_TOKEN = 'REFRESH_ACCESS_TOKEN';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export function SignInAction(isSignedIn, accessToken, refreshToken, userSeq, role, fullName, rememberSignedId, lastSignedInId) {
    return {
        type: SIGN_IN,
        isSignedIn,
        accessToken,
        refreshToken,
        userSeq,
        role,
        fullName,
        rememberSignedId,
        lastSignedInId
    };
}
export function SignOutAction(data) {
    return { type: SIGN_OUT, data };
}

export function RefreshAccessTokenAction(token) {
    return { type: REFRESH_ACCESS_TOKEN, token };
}
